export default "__VITE_ASSET__de01e92a__"